module.exports = __webpack_public_path__ + "static/media/table.2b656098.png";